import { useState, useEffect } from 'react';

const useShippingCountry = (locale) => {
  const [country, setCountry] = useState(() => {
    const storedCountry = sessionStorage.getItem("defaultShippingEstimateCountry");
    return storedCountry || locale.split("-")[1];
  });
  useEffect(() => {
    const handleStorageChange = () => {
      const updatedCountry = sessionStorage.getItem("defaultShippingEstimateCountry");
      if (updatedCountry && updatedCountry !== country) {
        setCountry(updatedCountry);
      }
    };
    window.addEventListener("session-storage-country-changed", handleStorageChange);
    return () => {
      window.removeEventListener("session-storage-country-changed", handleStorageChange);
    };
  }, [country]);
  return country.toUpperCase();
};

export { useShippingCountry };
//# sourceMappingURL=src-hooks-useShippingCountry.js.map
